<template>
  <div>
    <file-download
      :download="download"
      :link="imageSrc"
      :save-file="false"
      @fileDownloaded="fileDownloaded"
      @fileNotDownloaded="fileNotDownloaded">
    </file-download>
    <weex-image
      :src="imageFile"
      :style="imageStyle"
      class="horizontal_center"
      @click="onImageClicked">
    </weex-image>
  </div>
</template>

<script>

  import FileDownload from '@/components/layout/FileDownload'

  export default {
    name: "ShowFileItem",
    components: { FileDownload },
    data: () => ({
      download: false,
      imageFile: ''
    }),
    props: {
      showAsDialog: {
        type: Boolean,
        default: false
      },

      showCircular: {
        type: Boolean,
        default: true
      },

      imageXRadius: {
        type: Number,
        default: 150
      },

      imageYRadius: {
        type: Number,
        default: 150
      },

      imageSrc: {
        type: String,
        required: true
      }
    },

    methods: {
      onImageClicked() {
        this.$emit('imageClicked', {})
      },

      showFile() {
        this.imageFile = ''
        this.download = true
      },

      fileDownloaded(e) {
        this.download = false
        this.imageFile = e.bufferUrl
      },

      fileNotDownloaded() {
        this.download = false
      }
    },

    computed: {
      imageStyle() {
        const width = 2 * this.imageXRadius + 'px'
        const height = 2 * this.imageYRadius + 'px'
        const radius = (this.imageXRadius > this.imageYRadius ? this.imageXRadius
          : this.imageYRadius) + 'px'
        return {
          'height': height,
          'width': width,
          'border-radius': radius,
          'border-style': 'dashed',
          'border-color': '#808080',
          'border-width': '1px'
        }
      },
    },
  }

</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
